export const DATA_TYPE_KEY = Symbol.for('__serializedType__');
/**
 * @see https://github.com/reduxjs/redux-toolkit/blob/b718e01d323d3ab4b913e5d88c9b90aa790bb975/src/query/core/buildSlice.ts#L259
 */
export const missingTagId = '__internal_without_id';
